import React, { Component } from 'react'
import { Input, Form, Modal, Popconfirm, Button } from 'antd'
import Attachments from './Attachments'

const FormItem = Form.Item
const { TextArea } = Input

class AddEditForm extends Component {
  handleCreateHelp = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.handleAddHelp(values)
      form.resetFields()
    })
  }

  handleEditHelp = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.handleEditHelp(values)
      form.resetFields()
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.props.handleToggleAddEditForm()
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalVisible, currentHelp } = this.props
    return (
      <Modal
        visible={modalVisible}
        title="Help"
        okText={currentHelp ? 'Save Changes' : 'Add Item'}
        onCancel={this.handleCancel}
        onOk={currentHelp ? this.handleEditHelp : this.handleCreateHelp}
        width={currentHelp ? '90%' : 800}
        maskClosable={false}
      >
        <Form layout="vertical">
          {currentHelp && (
            <div className="pb-3">
              <div className="row">
                <div className="col-6">Created By:</div>
                <div className="col-6">Updated By:</div>
              </div>
              <div className="row">
                <div className="col-6">
                  <strong>{`${currentHelp.first_name_created_by} ${
                    currentHelp.last_name_created_by
                  }`}</strong>
                </div>
                <div className="col-6">
                  <strong>{`${currentHelp.first_name_updated_by} ${
                    currentHelp.last_name_updated_by
                  }`}</strong>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Title">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      required: true,
                      message: 'Title cannot be blank.'
                    }
                  ],
                  initialValue: currentHelp ? currentHelp.title : ''
                })(<Input placeholder="Enter title..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Body">
                {getFieldDecorator('body', {
                  initialValue: currentHelp ? currentHelp.body : ''
                })(<TextArea placeholder="Enter the body..." rows={10} />)}
              </FormItem>
            </div>
          </div>
        </Form>
        {currentHelp && (
          <Attachments
            currentId={this.props.currentId}
            userId={this.props.userId}
            attachmentList={this.props.attachmentList}
            loadingAttachments={this.props.loadingAttachments}
            uploadingAttachment={this.props.uploadingAttachment}
            uploadAttachment={this.props.uploadAttachment}
            updateAttachmentDescription={this.props.updateAttachmentDescription}
            deleteAttachment={this.props.deleteAttachment}
            deletingAttachment={this.props.deletingAttachment}
          />
        )}
        {currentHelp && (
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.props.handleDeleteHelp}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {currentHelp && <Button type="danger" icon="delete" />}
          </Popconfirm>
        )}
      </Modal>
    )
  }
}

export default Form.create()(AddEditForm)



// WEBPACK FOOTER //
// ./src/components/help/AddEditForm.js